
import React, { useState } from 'react';

import { ModelBase, PlayerObject } from "@models";
import { Creature } from "@dndModels";

import CommonUtilities from "@utilities/common_utilities";
import DandDAPI from "@dndUtilities/system_api";

import NonFSIndex from "@dndComponents/NonFSIndex";
import ToastBox from "@components/display/ToastBox";
import CopyButton from "@components/input/buttons/CopyButton";

const common_util = CommonUtilities.getInstance();
const api = DandDAPI.getInstance();

export default function CreatureIndex() {
  const [toast_time, setToastTime] = useState(-1);

  return (
    <>
      <NonFSIndex
        data_type="creature_gift"
        show_image
        // extra_filter={(obj: ModelBase | PlayerObject) => {
        //   if (obj instanceof Creature && obj.min_challenge_rating !== obj.max_challenge_rating) {
        //     return !obj.table.fields.includes("Armor Class");
        //   }
        //   return false;
        // }}
        extra={(copyMe: ModelBase | PlayerObject) => {
          if (copyMe instanceof Creature) {
            return (
              <CopyButton
                label="Clipboard"
                onClick={() => {
                  api.getFullObjectForClipboard("creature_gift", copyMe._id).then(res => {
                    navigator.clipboard.writeText(JSON.stringify(res));
                    setToastTime(common_util.get_time_number());
                  });
                }}
              />
            );
          }
        }}
      />
      <ToastBox
        openTime={ toast_time }
      >
        Copied to Clipboard
      </ToastBox>
    </>
  );
}
